export interface VoucherInformation {
  amount: number;
  available: number;
  availableAmount: number;
  calculatedAmount: number;
  configurationCode: string;
  currencyCode: string;
  customerNumber: string;
  expiration: string;
  firstName: string;
  foreignAmount: number;
  foreignAvailableCurrencyCode: string;
  foreignCalculatedAmount: number;
  foreignCalculatededCurrencyCode: string;
  foreignCurrencyCode: string;
  foreignReversableAmount: number;
  lastName: string;
  nameRestriction: VoucherNameRestriction;
  password: string;
  personKey: string;
  recordLocator: string;
  redeemableAmount: number;
  reference: string;
  reversableAmount: number;
  status: VoucherStatus;
  transactions: VoucherTransaction[];
  type: VoucherType;
  voucherIssuanceKey: string;
  voucherKey: string;
}

export enum VoucherNameRestriction {
  None = 0,
  MustBePassenger = 1,
  MustBePassengerOrContact = 2,
}

export enum VoucherType {
  Credit = 0,
  SingleUseCredit = 1,
  Service = 2,
  SingleUse = 3,
  MultiUse = 4,
  SingleUseNegativeAdjustment = 5,
  PassengerSelect = 6,
}

export interface VoucherTransaction {
  amount: number;
  currencyCode: string;
  foreignAmount: string;
  foreignCurrencyCode: string;
  recordLocator: string;
  type: VoucherTransactionType;
  voucherTransactionKey: string;
}

export enum VoucherStatus {
  Available = 0,
  Void = 1,
  Redeemed = 2,
  Expired = 3,
}

export enum VoucherTransactionType {
  Debit = 0,
  Credit = 1,
  Void = 2,
  Reinstate = 3,
  Adjustment = 4,
  ExpirationDateChange = 5,
  VoucherTypeChange = 6,
}
